import { render, staticRenderFns } from "./add-department.vue?vue&type=template&id=59cc5222&"
import script from "./add-department.vue?vue&type=script&lang=js&"
export * from "./add-department.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports